import { useCallback } from 'react'

import { F0Box, F0Button, OneEllipsis, type DataDownloadCanvasContent } from '@factorialco/f0-react'
import { Cross, Download } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { downloadAsCsv } from './download'
import { useDataDownloadView } from './DataDownloadProvider'

export type DataDownloadHeaderProps = {
  content: DataDownloadCanvasContent
  onClose: () => void
}

export function DataDownloadHeader({ content, onClose }: DataDownloadHeaderProps) {
  const { filename = 'dataset' } = content
  const { getFilteredDataset } = useDataDownloadView()

  const handleDownload = useCallback(() => {
    downloadAsCsv(getFilteredDataset(), filename)
  }, [getFilteredDataset, filename])

  const parsedTitle = content.title.replaceAll('_', ' ')

  return (
    <F0Box
      display="flex"
      alignItems="center"
      gap="md"
      shrink={false}
      border="none"
      borderBottom="default"
      borderColor="secondary"
      padding="xl"
    >
      <OneEllipsis tag="h2" className="min-w-0 flex-1 text-2xl font-semibold text-f1-foreground">
        {parsedTitle}
      </OneEllipsis>
      <F0Box display="flex" alignItems="center" gap="md">
        <F0Button
          variant="outline"
          size="md"
          icon={Download}
          label={i18n.t('common.ai.data_download.download_csv')}
          onClick={handleDownload}
        />
      </F0Box>
      <F0Button
        variant="outline"
        size="md"
        icon={Cross}
        hideLabel
        onClick={onClose}
        label={i18n.t('common.close')}
      />
    </F0Box>
  )
}
